import React, { useEffect, useState } from "react";
import api from "../services/api";
import {
  Card,
  CardBody,
  Table,
  Button,
  Input,
  Spinner,
  Alert,
} from "reactstrap";
import { FaPrint } from "react-icons/fa";

const PaySummary = () => {
  const [payrollData, setPayrollData] = useState([]);
  const [employee, setEmployee] = useState({});
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const empRes = await api.post("/employee/profile");
        setEmployee(empRes.data || {});
        const payRes = await api.get("/employee/payroll");
        setPayrollData(payRes.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load payroll data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCheckboxChange = (record) => {
    setSelectedRecords((prev) => {
      const exists = prev.find((r) => r.id === record.id);
      if (exists) {
        return prev.filter((r) => r.id !== record.id);
      } else {
        return [
          ...prev,
          {
            id: record.id,
            employee_id: record.employee_id,
            pay_date: record.pay_date,
            start_date: record.start_date,
            end_date: record.end_date,
          },
        ];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRecords([]);
      setSelectAll(false);
    } else {
      const all = payrollData.map((r) => ({
        id: r.id,
        employee_id: r.employee_id,
        pay_date: r.pay_date,
        start_date: r.start_date,
        end_date: r.end_date,
      }));
      setSelectedRecords(all);
      setSelectAll(true);
    }
  };

  const isRowSelected = (record) =>
    selectedRecords.some((r) => r.id === record.id);

  const handlePrint = async () => {
    if (selectedRecords.length === 0) {
      alert("Select at least one record to print.");
      return;
    }
  
    try {
      const response = await api.post(
        `/emp-pay-print`,
        {
          ids: selectedRecords.map((r) => r.id), // ✅ Only send IDs
        },
        { responseType: "blob" }
      );
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "pay_summary.pdf";
      link.click();
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to generate PDF.");
    }
  };
  

  if (loading)
    return (
      <p className="text-center mt-5">
        <Spinner /> Loading payroll data...
      </p>
    );

  return (
    <Card className="shadow-lg mt-4">
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0">Pay Summary</h3>
          <Button
            color="info"
            onClick={handlePrint}
            disabled={selectedRecords.length === 0}
          >
            <FaPrint className="me-2" />
            Save PDF
          </Button>
        </div>

        {error && <Alert color="danger">{error}</Alert>}

        <p className="text-muted">
          Welcome, {employee.first_name} {employee.last_name}
        </p>
        <h6>Employee ID: {employee.id} | Business ID: {employee.business_id}</h6>

        <Table bordered responsive className="mt-3">
          <thead>
            <tr>
              <th>
                <Input
                  type="checkbox"
                  checked={
                    selectedRecords.length === payrollData.length &&
                    payrollData.length > 0
                  }
                  onChange={handleSelectAll}
                />
              </th>
              <th>Pay Date</th>
              <th>Gross Pay</th>
              <th>Net Pay</th>
            </tr>
          </thead>
          <tbody>
            {payrollData.map((record) => (
              <tr key={record.id}>
                <td>
                  <Input
                    type="checkbox"
                    checked={isRowSelected(record)}
                    onChange={() => handleCheckboxChange(record)}
                  />
                </td>
                <td>{new Date(record.pay_date).toLocaleDateString()}</td>
                <td>${record.grosspay}</td>
                <td>${record.net_pay}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        {payrollData.length === 0 && (
          <p className="text-muted mt-3 text-center">
            No payroll records found.
          </p>
        )}
      </CardBody>
    </Card>
  );
};

export default PaySummary;


// // src/pages/PaySummary.js
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../services/api";
// import { Table, Alert, Button, Card, CardBody } from "reactstrap";

// const PaySummary = () => {
//   const [payrollData, setPayrollData] = useState([]);
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [employee, setEmployee] = useState({});
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchPayrollData = async () => {
//       try {
//         const employeeResponse = await api.post("/employee/profile");
//         setEmployee(employeeResponse.data);

//         const payrollResponse = await api.get("/employee/payroll");
//         setPayrollData(payrollResponse.data || []);
//       } catch (err) {
//         console.error(err);
//         setError(err.response?.data || "Failed to load payroll data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPayrollData();
//   }, []);

//   if (loading) return <p className="text-center mt-5">Loading payroll data...</p>;

//   return (
//     <Card className="shadow-lg mt-4">
//       <CardBody>
//         <h3 className="mb-4 text-center">Pay Summary</h3>
//         {error ? (
//           <Alert color="danger">
//             {error}
//             <br />
//             <Button color="link" onClick={() => navigate("/emp-login")}>
//               Click here to log in again.
//             </Button>
//           </Alert>
//         ) : (
//           <>
//             <p className="text-muted text-center">Welcome, {employee.first_name} {employee.last_name}</p>
//             <h5 className="text-center">Employee ID: {employee.id}</h5>
//             <h5 className="text-center">Business ID: {employee.business_id}</h5>

//             {payrollData.length > 0 ? (
//               <Table striped bordered responsive className="mt-4">
//                 <thead>
//                   <tr>
//                     <th>Pay Period</th>
//                     <th>Gross Pay</th>
//                     <th>Net Pay</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {payrollData.map((record) => (
//                     <tr key={record.id}>
//                       <td>{new Date(record.pay_date).toLocaleDateString()}</td>
//                       <td>${record.grosspay}</td>
//                       <td>${record.net_pay}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             ) : (
//               <p className="text-muted text-center mt-3">No payroll records available.</p>
//             )}
//           </>
//         )}
//       </CardBody>
//     </Card>
//   );
// };

// export default PaySummary;
